import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';
import { getProjects, updateMetadataProjectFail } from 'store/actions';

const initialState = {
    parentProjects: [],
    projectTree: [],
    activeProject: null,
    order: [],
    error: null,
    loading: false,
	children: {}
};

const getProjectTreeStart = (state, action) => {
    return updateObject( state, { error: null, loading: true } );
}

const getProjectTreeFail = (state, action) => {
    return updateObject( state, {
        error: action.error,
        loading: false
    });
}

// function wrap child projects into children of project
const getProjectChildren = (level, root, allProjects) => {
    // init children object
    let children = [];
    // init length counter
    let length = 0;
    // check if level has children
    if (level.children.length > 0) {
        // process children
        level.children.forEach((item, index) => {
            // init item
            let _item = item.project;
			// root project id
			_item.root = root
            // update object with metadata
            updateObject(_item, item.project.data.metadata.fields);
            // set created (for sorting)
            _item['created'] = item.project.metadata.fields.created;
            // set originalObject
            _item.originalObject = _item;
            // append project
            children[length] = _item;
            children[length]['children'] = getProjectChildren(item, root, allProjects);
			allProjects[item.project.getId()] = _item;
            // increment length
            length ++;
        });
    }
    // return child tree
    return children;
};

const getProjectTreeSuccess = (state, action) => {
    console.log(action);
	const allProjects = {};
    const parentProjects = [];
    let projectTree= [];
    // init length counter
    let length = 0;
    // process first level
    action.children.forEach((item, index) => {
        parentProjects.push(item.project.getId());
		 
        // init item
        let _item = item.project;
		// root project id
		_item.root = item.project.getId();
        // update object with metadata
        updateObject(_item, item.project.data.metadata.fields);
        // set created (for sorting)
        _item['created'] = item.project.metadata.fields.created;
        // set originalObject
        _item.originalObject = _item;
        // append project
        projectTree[length] = _item;
        projectTree[length]['children'] = getProjectChildren(item, _item.root, allProjects);
		allProjects[item.project.getId()] = _item;
        // increment length
        length ++;
    });

    return updateObject(state, {
        parentProjects: parentProjects,
        projectTree: projectTree,
		allProjects: allProjects,
        loading: false
    });
}

const reducer = ( state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_PROJECT_TREE_START: 
			return getProjectTreeStart(state, action);
        case actionTypes.GET_PROJECT_TREE_SUCCESS: 
			return getProjectTreeSuccess(state, action);
        case actionTypes.GET_PROJECT_TREE_FAIL: 
			return getProjectTreeFail(state, action);
        default: 
            return state;
    }
}

export default reducer;
